import React from 'react';
import './AccessSummaryPanel.css';

export default function AccessSummaryPanel({
  user,
  caps,
  userCaps,
}) {
  const userAccess = userCaps.filter(uc => uc.userId === user.userId);

  return (
    <section className="access-control-panel access-summary-panel">
      <h2 className="access-control-section-title access-control-section-title--spaced">
        Camera Summary
      </h2>
      <dl className="access-summary-list">
        <div className="access-summary-item access-summary-item--owner">
          <dt>Admin Access</dt>
          <dd>{userAccess.filter(uc => uc.accessType === 'OWNER').length}</dd>
        </div>
        <div className="access-summary-item access-summary-item--viewer">
          <dt>Full Access</dt>
          <dd>{userAccess.filter(uc => uc.accessType === 'VIEWER').length}</dd>
        </div>
        <div className="access-summary-item access-summary-item--demo">
          <dt>Live View Only</dt>
          <dd>{userAccess.filter(uc => uc.accessType === 'DEMO').length}</dd>
        </div>
        <div className="access-summary-item access-summary-item--none">
          <dt>No Access</dt>
          <dd>{caps.length - userAccess.length}</dd>
        </div>
      </dl>
    </section>
  );
}
